import { useEffect, useState } from "react";
import NotificationsList from "./NotificationsList";

const sampleAdminNotifications = [
  {
    id: 1,
    userImg: "/assets/img/user2.jpg",
    badge: "Comment",
    badgeColor: "bg-pink-100 text-pink-700",
    title: "Sunil commented on your post",
    description:
      "You have received a new comment on your post. Please check and reply if needed.",
  },
  {
    id: 2,
    userImg: "/assets/img/user1.jpg",
    badge: "Message",
    badgeColor: "bg-yellow-100 text-yellow-700",
    title: "Suresh Sent You a Message",
    description:
      "You have a new direct message. Open your inbox to read and respond.",
  },
];

const sampleUserNotifications = [
  {
    id: 1,
    userImg: "/assets/img/user3.avif",
    badge: "Connection",
    badgeColor: "bg-purple-100 text-purple-700",
    title: "Karan Sent a Connection Request",
    description:
      "You have a new connection request. Accept to start networking.",
  },
];

const NotificationsPage = ({ type = "user" }) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    // Future
    // api.get(`/api/${type}-notifications`).then((res) => setNotifications(res.data));

    if (type === "admin") {
      setNotifications(sampleAdminNotifications);
    } else {
      setNotifications(sampleUserNotifications);
    }
  }, [type]);

  return (
    <div className="p-6">
      <h1 className="text-xl font-bold mb-4">
        {type === "admin" ? "Admin Notifications" : "User Notifications"}
      </h1>
      <NotificationsList
        notifications={notifications}
        setNotifications={setNotifications}
      />
    </div>
  );
};

export default NotificationsPage;
